import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Button,
  Typography,
} from "@mui/material";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import { useTranslation } from "react-i18next";

// Generic "coming soon" popup. Open it from any nav item / CTA that points
// to an unbuilt feature. Title + message are translation keys so the same
// dialog can serve every placeholder route (Knowledge, Fertilizer
// Availability, Plant Protection, …).
export const RewampComingSoonDialog = ({
  open,
  onClose,
  title = "REWAMP_COMING_SOON_TITLE",
  message = "REWAMP_COMING_SOON_MESSAGE",
  ctaLabel = "REWAMP_COMING_SOON_OKAY",
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="rewamp-coming-soon-title"
      PaperProps={{
        sx: {
          width: "412px",
          maxWidth: "calc(100% - 32px)",
          borderRadius: "12px",
          overflow: "hidden",
          p: 0,
        },
      }}
    >
      <DialogContent
        sx={{
          px: 3,
          pt: 4,
          pb: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            bgcolor: "background.tertiaryGreen",
            border: "1px solid",
            borderColor: "primary.interactive",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <HourglassTopIcon
            aria-hidden="true"
            sx={{ fontSize: 36, color: "primary.interactive" }}
          />
        </Box>

        <Box
          sx={{
            mt: 2.5,
            bgcolor: "accent.butterscotchBg",
            border: "1px solid",
            borderColor: "accent.butterscotch",
            borderRadius: "6px",
            px: 1.5,
            py: 0.5,
          }}
        >
          <Typography
            sx={{
              fontSize: "11px",
              fontWeight: 700,
              letterSpacing: "0.66px",
              textTransform: "uppercase",
              color: "accent.butterscotch",
              lineHeight: 1.2,
            }}
          >
            {t("REWAMP_COMING_SOON_BADGE")}
          </Typography>
        </Box>

        <Typography
          id="rewamp-coming-soon-title"
          component="h2"
          sx={{
            mt: 2,
            fontSize: "18px",
            fontWeight: 700,
            color: "text.primary",
          }}
        >
          {t(title)}
        </Typography>

        <Typography
          sx={{
            mt: 1,
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "23.1px",
            color: "text.secondary",
          }}
        >
          {t(message)}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          borderTop: "1px solid #E0E0D8",
          px: 3.5,
          py: 3.5,
          justifyContent: "center",
        }}
      >
        <Button
          variant="primary"
          onClick={onClose}
          sx={{ minWidth: 180, py: 1.5 }}
          autoFocus
        >
          {t(ctaLabel)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RewampComingSoonDialog;
